import { PageHeader } from "@shared/components/PageHeader";
import React from "react";
import TemplateList from "../list/list";
import {
  FieldTooltip,
  Tooltip,
  TooltipProvider,
  TooltipTrigger,
} from "@shared/ui/tooltip";
import { useNavigate } from "react-router-dom";
import { Button } from "@shared/ui/button";
import { PlusIcon } from "lucide-react";
const TemplatesLanding = () => {
  const CreateTemplateButton = () => {
    const navigate = useNavigate();

    const handleCreateTemplate = () => {
      navigate("/communication-hub/templates/choose");
    };

    return (
      <Button onClick={handleCreateTemplate}>
        <PlusIcon className="h-4 w-4 mr-2" />
        Add Template
      </Button>
    );
  };
  return (
    <div className="space-y-6 p-1">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <PageHeader
            title="Communication Templates"
            subtitle="Manage all communication templates for your organization."
          />
        </div>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <CreateTemplateButton />
            </TooltipTrigger>
            <FieldTooltip>Create a new message template</FieldTooltip>
          </Tooltip>
        </TooltipProvider>
      </div>
      <div className="mt-1">
        <TemplateList />
      </div>
    </div>
  );
};

export default TemplatesLanding;
